import { Button } from "@/components/ui/Button"

interface StepIndicatorProps {
  currentStep: number
  totalSteps: number
  onStepClick: (step: number) => void
}

export function StepIndicator({
  currentStep,
  totalSteps,
  onStepClick,
}: StepIndicatorProps) {
  return (
    <div
      className="tw-flex tw-gap-2 tw-items-center"
      data-testid="step-indicator"
    >
      {Array.from({ length: totalSteps }).map((_, index) => {
        const stepNumber = index + 1
        return (
          <Button
            key={index}
            type="button"
            onClick={() => onStepClick(stepNumber)}
            className={`tw-w-2 tw-h-2 tw-rounded-full tw-transition-all tw-cursor-pointer hover:tw-scale-150 tw-border-0 tw-p-0 tw-min-w-0 tw-min-h-0 ${
              stepNumber === currentStep
                ? "tw-bg-gray-800 tw-scale-125"
                : stepNumber < currentStep
                  ? "tw-bg-gray-600"
                  : "tw-bg-gray-300"
            }`}
            data-testid={`step-dot-${stepNumber}`}
            aria-label={`Go to step ${stepNumber}`}
          />
        )
      })}
    </div>
  )
}
